/**
 * 本地占位图片生成器
 */

export const generatePlaceholder = (
  width = 300, 
  height = 200, 
  text = '暂无图片', 
  bgColor = '#f5f5f7', 
  textColor = '#8e8e93'
) => {
  const fontSize = Math.min(width, height) * 0.1;
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
      <rect width="${width}" height="${height}" fill="${bgColor}"/>
      <text x="${width/2}" y="${height/2}" 
            font-family="system-ui, -apple-system, sans-serif" 
            font-size="${fontSize}" 
            text-anchor="middle" 
            dominant-baseline="middle" 
            fill="${textColor}">
        ${text}
      </text>
    </svg>
  `;
  
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

export const placeholderPresets = {
  article: {
    large: (text = '文章配图') => generatePlaceholder(500, 300, text),
    medium: (text = '文章配图') => generatePlaceholder(400, 240, text),
    small: (text = '文章配图') => generatePlaceholder(300, 200, text)
  },
  idea: {
    default: (text = '片语配图') => generatePlaceholder(300, 200, text),
    card: (text = '片语') => generatePlaceholder(280, 180, text)
  }
};

export const handleImageError = (event, fallbackType = 'article.medium', customText) => {
  const keys = fallbackType.split('.');
  let placeholder = placeholderPresets;
  
  for (const key of keys) {
    placeholder = placeholder[key];
    if (!placeholder) break;
  }
  
  if (typeof placeholder === 'function') {
    event.target.src = placeholder(customText);
  } else {
    event.target.src = generatePlaceholder(300, 200, customText || '图片加载失败');
  }
  
  event.target.classList.add('image-error');
}; 